import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import { getLinkProps } from '../../../utils';

import { withStyles } from '@material-ui/styles';
import styles from './styles';
import { muiTheme } from '../../../theme';

const AppName = ({ homePage, prefix, name, classes }) => {
  return (
    <Button className={classes.root} disableElevation {...getLinkProps(homePage)}>
      <span className={classes.prefix}>{prefix}</span>
      &nbsp;
      {name}
    </Button>
  );
};

AppName.propTypes = {
  prefix: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  homePage: PropTypes.object.isRequired,
};

export default withStyles(styles(muiTheme))(AppName);
